<template>
  <Teleport to="body">
    <transition name="fade">
      <div v-if="props.shouldShowModal">
        <div class="modal-bg bg-black-transparent-60">
          <div class="flex h-full w-full flex-col items-end justify-center gap-y-2 px-6" :class="props.customWidth">
            <div v-if="props.onClose" class="p-3" @click="props.onClose">
              <img alt="モーダルを閉じるボタン" class="mr-2 h-3 w-3 cursor-pointer md:h-4 md:w-4" src="@/assets/icon/close/white.svg" />
            </div>
            <div ref="target" class="max-h-[calc(100%_-_64px)] w-full overflow-auto bg-white" :class="[{ 'px-6 py-4': !props.withoutPadding }, { 'rounded-lg': props.rounded }]">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script lang="ts" setup>
import { onClickOutside } from '@vueuse/core';

interface Props {
  shouldShowModal: boolean;
  // eslint-disable-next-line vue/require-default-prop
  onClose?: () => void; // モーダルを閉じる処理
  customWidth?: string;
  rounded?: boolean;
  withoutPadding?: boolean;
}

const props = withDefaults(defineProps<Props>(), { customWidth: 'max-w-[624px]', withoutPadding: false, rounded: false });

const target = ref<HTMLElement | null>(null); // click-outsideの対象の要素

if (props.onClose) {
  onClickOutside(target, props.onClose);
}
</script>

<style lang="scss" scoped>
.modal-bg {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  width: 100vw;
  height: auto;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  z-index: 200;
}
</style>
